export default __webpack_public_path__ + "book_details-file_size.fc6e03e6.png";